<template>
    <div class="home-container">
        <div class="header">
            <img src="../assets/img/logo.png" alt="logo" class="logo">
            <div class="menu" @click="menuHandler" :class="{ 'menu-active': menuListShow }">
                <img src="../assets/img/menu.png" v-if="menuListShow" alt="menu" class="menu-icon">
                <img src="../assets/img/menu-active.png" v-else alt="menu" class="menu-icon">
                <div class="menu-list" v-show="menuListShow">
                    <game-link v-for="(menu, index) in menuList" @click.stop="menuHandler" class="menu-list-item" :class="{ 'menu-list-item-last-child': index === menuList.length - 1 }" :key="index" :href="menu.href">
                        <img :src="menu.icon" class="menu-list-icon" />
                        <span class="menu-text">{{ menu.name }}</span>
                    </game-link>
                </div>
            </div>
        </div>
        <div class="hot-game module-container">
            <div class="module-title">
                <img src="../assets/img/hot-game.png" alt="hot-game" class="module-title-icon">
                <span class="module-title-text">Hot Game</span>
            </div>
        </div>
        <div class="scroll-container">
            <game-link v-for="(game, index) in game1" :key="game.apkKey" :href="getHref(game.apkKey, 'game')">
                <div class="scroll-item" :class="{ 'last-child': index === game1.length - 1 }">
                    <img :src="game.screenshots[0]" class="game-icon" height="137" style="border-radius: 0; object-fit: cover;" />
                    <div class="scroll-item-bottom">
                        <div>
                            <img :src="game.iconUrl" alt="game-icon" class="game-icon">
                        </div>
                        <div class="scroll-item-bottom-right">
                        <div class="game-name">{{ game.name }}</div>
                        <div class="game-bottom">
                            <div class="game-type">{{ game.category }}</div>
                            <div class="game-rating">
                                <rate :count="game.rating" />
                                {{ game.rating }}</div>
                        </div>

                        </div>
                    </div>
                </div>
            </game-link>
        </div>
        <div class="new-game module-container" id="new-game">
            <div class="module-title">
                <img src="../assets/img/new-game.png" alt="hot-game" class="module-title-icon">
                <span class="module-title-text">New Game</span>
            </div>
        </div>
        <div class="module-1 module-item">
            <game-link v-for="(game, index) in game2" :key="game.apkKey" :href="getHref(game.apkKey, 'game')">
                <img :src="game.iconUrl" class="game-icon" />
                <div class="game-name-1">{{ game.name }}</div>
            </game-link>
        </div>
        <div class="best-game module-container" id="best-game">
            <div class="module-title">
                <img src="../assets/img/best-game.png" alt="hot-game" class="module-title-icon">
                <span class="module-title-text">Best Game</span>
            </div>
        </div>
        <div class="module-2 module-item">
             <game-link v-for="(game, index) in game3" class="module-2-item-game" :key="game.apkKey" :href="getHref(game.apkKey, 'game')">
                <img :src="game.iconUrl" class="module-2-item-game-icon" />
                <div class="module-2-center">
                    <div class="game-name-2">{{ game.name }}</div>
                    <rate :count="game.rating" />
                    <div class="type-container">
                        <div class="game-type">{{ game.category }}</div>
                    </div>
                </div>
                <div class="module-2-right">
                    Download
                </div>
            </game-link>
        </div>
        <div class="all-game module-container" id="all-game">
            <div class="module-title">
                <img src="../assets/img/all-game.png" alt="hot-game" class="module-title-icon">
                <span class="module-title-text">All Game</span>
            </div>
        </div>
        <div class="module-1 module-item">
            <game-link v-for="(game, index) in games" :key="game.apkKey" :href="getHref(game.apkKey, 'game')">
                <img :src="game.iconUrl" class="game-icon" />
                <div class="game-name-1">{{ game.name }}</div>
            </game-link>
        </div>
        <rush-footer />
    </div>
</template>

<script>
    import NewGame from '../assets/img/new-game.png';
    import BestGame from '../assets/img/best-game.png';
    import AllGame from '../assets/img/all-game.png';
    import games from '../data/site.json'
    import { getHref } from '../assets/js/url'
    export default {
        name: "Home",
        data() {
            return {
                menuListShow: false,
                menuList: [
                    { name: 'New Game', icon: NewGame, href: '#new-game' },
                    { name: 'Best Game', icon: BestGame, href: '#best-game' },
                    { name: 'All Game', icon: AllGame, href: '#all-game' },
                ],
                game1: games.slice(0, 3),
                game2: games.slice(3, 12),
                game3: games.slice(12, 18),
                games,
            }
        },
        methods: {
            menuHandler() {
                this.menuListShow = !this.menuListShow;
            },
            getHref
        }
    };
</script>

<style lang="less" scoped>
    .home-container {
        margin: 0 auto;
        max-width: 560px;
        height: 100vh;

        .header {
            padding: 33px 25px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .logo {
            height: 29px;
        }

        .menu {
            position: relative;
            width: 56px;
            height: 36px;
            opacity: 1;
            border-radius: 117px;
            background: rgba(66, 61, 54, 1);
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .menu-icon {
            width: 13.93px;
            height: 12.01px;
        }
    }

    .module-title {
        display: flex;
        align-items: center;

        img {
            width: 20.17px;
            height: 14.67px;
            border-radius: 0px 0px 0px 0px;
            margin-right: 10px;
        }

        .module-title-text {
            font-size: 19px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
        }
    }

    .scroll-item {
        width: 236px;
        height: 194px;
        border-radius: 15px;
        background: rgba(58, 50, 43, 1);
        margin-right: 15px;
        overflow: hidden;

        .game-icon {
            width: 100%;
            border-radius: 15px;
        }
    }

    .last-child {
        margin-right: 25px;
    }

    .scroll-item-bottom {
        display: flex;
        align-items: center;
        padding: 8px 8px 0;
        box-sizing: border-box;

        .game-icon {
            width: 40px;
            height: 40px;
            border-radius: 10px;
            margin-right: 8px;
        }
    }

    .game-name {
        font-size: 15px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
    }

    .game-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 5px;
    }

    .game-type {
        padding: 3px 6px;
        border-radius: 5px;
        border: 0.5px solid rgba(159, 151, 144, 1);
        font-size: 9px;
        font-weight: 400;
        color: rgba(159, 151, 144, 1);
    }

    .module-container {
        margin-bottom: 15px;
        padding: 0 25px;
    }

    .scroll-container {
        display: flex;
        overflow-x: auto;
        margin-left: 25px;
        margin-bottom: 35px;
    }

    .game-rating {
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 11px;
        font-weight: 400;
        color: rgba(241, 209, 172, 1);
    }

    .module-item {
        margin: 0 25px;
    }

    .module-1 {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 15px 26px;
        margin-bottom: 35px;

        .game-icon {
            width: 100%;
            border-radius: 15px;
        }
    }

    .game-name-1 {
        font-size: 13px;
        width: 94px;
        margin: 5px auto 0;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
    }

    .game-name-2 {
        font-size: 15px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 8px;
        width: 127px;
    }

    .type-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .menu-list {
        position: absolute;
        width: 156px;
        height: 162px;
        border-radius: 15px;
        background: rgba(66, 61, 54, 1);
        bottom: -172px;
        right: 0;
        padding: 28px 18px;
    }

    .menu-list-icon {
        width: 20.17px;
        height: 14.67px;
        opacity: 1;
        border-radius: 0px 0px 0px 0px;
        margin-right: 11px;
    }

    .menu-list-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid rgba(79, 73, 65, 1);

        &:first-child {
            padding-top: 0;
        }
    }

    .menu-text {
        font-size: 15px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
    }

    .menu-list-item-last-child {
        border-bottom: 0;
    }

    .module-2-item-game {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        opacity: 1;
        border-radius: 15px;
        background: rgba(58, 50, 43, 1);
        padding-left: 5px;
        padding-right: 15px;
        margin-bottom: 10px;
    }

    .module-2-item-game-icon {
        width: 70px;
        height: 70px;
        border-radius: 15px;
        flex-shrink: 0;
    }

    .module-2-center {
        flex: 1;
        margin-left: 10px;
        flex-shrink: 0;
    }

    .type-container {
        display: flex;
        margin-top: 11px;
    }

    .module-2-right {
        width: 83px;
        height: 32px;
        border-radius: 68px;
        background: rgba(240, 246, 135, 1);
        font-size: 11px;
        font-weight: 700;
        color: rgba(36, 27, 21, 1);
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .module-2 {
        margin-bottom: 35px;
    }

    .menu-active {
        background: #000 !important;
    }

    .scroll-item-bottom-right {
        flex: 1;
    }
</style>